import React, { useMemo, useRef } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// store
import { storeSet, useStoreValue } from '../../store';

// components
import set404FromErrorResponse from '../../helpers/set404FromErrorResponse';
import FormField from '../../components/FormField';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

// api
import UserService from '../../service/user-service';

// tools
import getDateFromISOstring from '../../helpers/getDateFromISOstring';

const ProfileBeneficiario = () => {
    const isAsyncRequest = useStoreValue('isAsyncRequest');
    const userData = useStoreValue('userData');
    const toast = useRef(null);
    const urlTermsPdf = '/static/TERMINI_E_CONDIZIONI.pdf'

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: useMemo(() => {
            return userData;
        }, [userData]),
        mode: 'onChange'
    });

    const onSubmit = (formData) => {
        storeSet('setAsyncRequest');

        UserService.updateUserSelf(userData.id, formData, updateCallback, updateError);
    };

    const updateCallback = (data) => {
        if (data.status === 'SUCCESS') {
            storeSet('userData', data.data);
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: '',
                    detail: __('L\'utente è stato aggiornato!', 'htr')
                });
            }
        }
        storeSet('unsetAsyncRequest');
    }

    const updateError = (data) => {
        set404FromErrorResponse(data);
        storeSet('unsetAsyncRequest');
    }

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Profilo utente', 'htr')}</h1>
            </div>

            <div className="appPage__spacer"></div>
            <Toast ref={toast}/>

            <form className="appForm" onSubmit={handleSubmit(onSubmit)}>

                <div className="appPageSection">
                    <h2>{__('Informazioni personali', 'htr')}</h2>
                    <div className="appForm__cols">
                        <FormField
                            type="textinput"
                            disabled={isAsyncRequest}
                            fieldName="firstName"
                            label={__('Nome', 'htr')}
                            control={control}
                            errors={errors}
                            config={{ required: __('È obbligatorio', 'htr') }}
                            placeholder="Mario"
                        />

                        <FormField
                            type="textinput"
                            disabled={isAsyncRequest}
                            fieldName="lastName"
                            label={__('Cognome', 'htr')}
                            control={control}
                            errors={errors}
                            config={{ required: __('È obbligatorio', 'htr') }}
                            placeholder="Rossi"
                        />

                        <FormField
                            type="textinput"
                            disabled={isAsyncRequest}
                            fieldName="codiceFiscale"
                            label={__('Codice fiscale', 'htr')}
                            control={control}
                            errors={errors}
                            config={{ required: __('È obbligatorio', 'htr') }}
                            placeholder="XXXXXXXX"
                        />
                    </div>
                    <div className="appForm__cols">
                        <FormField
                            type="textinput"
                            fieldName="email"
                            disabled={isAsyncRequest}
                            label={__('Email', 'htr')}
                            control={control}
                            errors={errors}
                            config={{ required: __('È obbligatorio', 'htr') }}
                            placeholder="user@example.com"
                        />

                        <FormField
                            type="textinput"
                            fieldName="phoneNumber"
                            disabled={isAsyncRequest}
                            label={__('Telefono', 'htr')}
                            control={control}
                            errors={errors}
                            placeholder="1234567"
                        />
                    </div>
                </div>

                <div className="appPageSection">
                    <h2>{__('Consensi', 'htr')}</h2>

                    <div className="appForm__switchFieldWrapper">
                        <FormField
                            type="switch"
                            disabled={true}
                            fieldName="privacy"
                            label={''}
                            control={control}
                            errors={errors}
                            onLabel={''}
                            offLabel={''}
                        />
                        <div>
                            <p className="m-0">
                                {__('HTR BONIFICHE S.r.l., per quanto di ragione, società con sede legale in Via Bassano del Grappa, 4 – 00195 Roma, Italia (di seguito, “HTR” o il “Titolare”), informano che i dati forniti da ciascuno, sia nell’utilizzo di questo sito web, sia nelle circostanze più avanti specificate, saranno oggetto di trattamento nei termini di seguito descritti, che costituiscono “informativa” ai sensi dell’art. 13 del Regolamento Generale sulla Protezione dei Dati Personali 2016/679 (di seguito, “GDPR” o “Regolamento”), nonché del D.Lgs. 30.6.2003 n. 196, come modificato dal D.Lgs. n. 101/2018.', 'htr')}
                            </p>
                            <p>
                                <a href="https://gruppohtr.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
                            </p>
                        </div>
                    </div>

                    <div className="appForm__switchFieldWrapper">
                        <FormField
                            type="switch"
                            disabled={true}
                            fieldName="terms"
                            label={''}
                            control={control}
                            errors={errors}
                            onLabel={''}
                            offLabel={''}
                        />
                        <div>
                            <a href={urlTermsPdf} target="_blank" rel="noreferrer">{__('Termini e condizioni', 'htr')}</a>
                        </div>
                    </div>

                    <div className="appForm__switchFieldWrapper">
                        <FormField
                            type="switch"
                            fieldName="marketing"
                            disabled={isAsyncRequest}
                            label={''}
                            control={control}
                            errors={errors}
                            onLabel={''}
                            offLabel={''}
                        />
                        <div>
                            {__('Invio di materiale pubblicitario, vendita diretta, compimento di ricerche di mercato o comunicazione commerciale riguardanti promozione e vendita di prodotti e servizi della HTR, mediante modalità di contatto automatizzate (posta elettronica, PEC, messaggi tramite canali informatici, network ed applicazioni web) e tradizionali (come posta cartacea e chiamate telefoniche con operatore)', 'htr')}
                        </div>
                    </div>

                    <div className="appForm__switchFieldWrapper">
                        <FormField
                            type="switch"
                            fieldName="offers"
                            disabled={isAsyncRequest}
                            label={''}
                            control={control}
                            errors={errors}
                            onLabel={''}
                            offLabel={''}
                        />
                        <div>
                            {__('Elaborazione, in forma elettronica, dei dati relativi ai rapporti e servizi forniti, per l’analisi di comportamenti e preferenze della clientela, da utilizzare a scopo commerciale, per la individuazione ed offerta di prodotti e servizi di suo interesse', 'htr')}
                        </div>
                    </div>

                    <div className="appForm__switchFieldWrapper">
                        <FormField
                            type="switch"
                            fieldName="thirdParty"
                            disabled={isAsyncRequest}
                            label={''}
                            control={control}
                            errors={errors}
                            onLabel={''}
                            offLabel={''}
                        />
                        <div>
                            {__('Comunicazione dei miei dati ad altre società in ambito bancario, finanziario od assicurativo e enti pubblici che li tratteranno per invio di materiale pubblicitario, vendita diretta, compimento di ricerche di mercato o comunicazione commerciale riguardanti loro prodotti o servizi, mediante le modalità automatizzate e tradizionali di comunicazione sopra indicate', 'htr')}
                        </div>
                    </div>
                </div>

                <div className="appPageSection">
                    <h2>{__('Impostazioni', 'htr')}</h2>
                    <div className="appForm__cols">
                        <FormField
                            type="select"
                            disabled={isAsyncRequest}
                            fieldName="language"
                            defaultValue={'it'}
                            label={__('Lingua predefinita', 'htr')}
                            control={control}
                            errors={errors}
                            config={{ required: __('È obbligatorio', 'htr') }}
                            options={[
                                { label: __('Italiano', 'htr'), name: 'it' }
                            ]}
                        />

                        <FormField
                            type="select"
                            disabled={isAsyncRequest}
                            fieldName="timezone"
                                defaultValue={'Europe/Rome'}
                                label={__('Fuso Orario', 'htr')}
                                control={control}
                                errors={errors}
                                config={{ required: __('È obbligatorio', 'htr') }}
                                options={[
                                    { label: __('Europe/Rome', 'htr'), name: 'Europe/Rome' }
                                ]}
                            />

                            <FormField
                                type="select"
                                disabled={isAsyncRequest}
                                fieldName="dateformat"
                                defaultValue={'DD/MM/YY'}
                                label={__('Formato Data', 'htr')}
                                control={control}
                                errors={errors}
                                config={{ required: __('È obbligatorio', 'htr') }}
                                options={[
                                    { label: __('DD/MM/YY', 'htr'), name: 'DD/MM/YY' }
                                ]}
                            />
                        </div>
                    </div>

                    <div className="appPageSection">
                        <h2>{__('Sicurezza', 'htr')}</h2>
                        <div className="appForm__row">
                            <label>{__('Ultimo accesso', 'htr')}</label>
                            <span>{getDateFromISOstring(userData.lastLogin)}</span>
                        </div>
                    </div>

                    <div className="appPage__spacer"></div>

                    <div className="appPageSection__hr">
                        <span>{__('Azioni rapide', 'htr')}</span>
                    </div>

                    <div className="appPage__spacer"></div>

                    <div className="appPageSection">
                        <div className="appPageSection__actions">
                            <Button
                                disabled={isAsyncRequest}
                                label={__('Salva modifiche', 'htr')}
                                icon="pi pi-check" iconPos="right"/>
                        </div>
                    </div>
            </form>

        </div>
)

}

export default ProfileBeneficiario;